/**
 * lastShowsChannel.tsx
 */
import MainTemplate from '@components/templates/main/ui/main';
import Rail from '@shared/classes/rail';
import lastShowsChannelObservable from '@shared/api/lastShowsChannel/observable';
import useComplete from '@shared/components/utils/hooks/useComplete';
import { Observer, Subscription } from 'rxjs';
import { selectCurrentParams } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect, useState } from 'react';

/**
 * Displays the last shows channel page with the rails.
 */
export default function LastShowsChannel() {
  // Selectors
  const currentParams = useAppSelector(selectCurrentParams);

  // State
  const [complete, setComplete] = useComplete();
  const [rails, setRails] = useState<Rail[]>(
    (currentParams as { rails: Rail[] })?.rails || []
  );

  // Effect hooks

  /**
   * Effect hook that retrieves the last shows channel data.
   */
  useEffect(() => {
    let subscription: Subscription | null;
    if (!complete) {
      const lastShowsObserver: Observer<{
        data: Rail[];
      }> = {
        next: (val) => {
          setRails(val.data);
        },
        error: () => {
          console.error('Error recovering corners');
        },
        complete: () => {
          setComplete(true);
          return null;
        },
      };
      if (currentParams?.channelCode) {
        subscription = lastShowsChannelObservable(
          (currentParams as { channelCode: string }).channelCode,
          (currentParams as { channelId: string }).channelId
        ).subscribe(lastShowsObserver as Partial<Observer<unknown>>);
      }
    }
    return () => {
      subscription?.unsubscribe();
    };
  }, [complete]);

  // Render
  return <MainTemplate flags={{ complete }} rails={rails} />;
}
